import { useRouter } from 'next/router'
import { createContext, useContext, useMemo } from 'react'

const PageContext = createContext()

const PageProvider = ({ pageProps, children }) => {
	// importing router from 'next/router' throws a SSR warning:
	// "you cannot use next/router outside of a client component"
	const { asPath, pathname } = useRouter()

	// remove first and last slash from pathname and asPath
	const routerPathname = useMemo(() => pathname.replace(/^\/|\/$/g, ''), [pathname])
	const routerAsPath = useMemo(() => asPath.replace(/^\/|\/$/g, ''), [asPath])

	// if router pathname is [[...paths]] (dynamic route), use router asPath as entity type
	// we cannot always use router asPath because it can contain a query param (e.g. /search?q=foo)
	const forcedEntityType = useMemo(
		() => (routerPathname === '[[...paths]]' ? routerAsPath : routerPathname),
		[routerAsPath, routerPathname]
	)

	const contextValue = useMemo(
		() => ({
			...pageProps,
			entityType: pageProps?.entityType ?? forcedEntityType,
			// if page props have an entity id, use entity id if exists, otherwise use router asPath
			__bhEntityId: pageProps?.entityType ? pageProps?.entityId ?? forcedEntityType : forcedEntityType,
		}),
		[pageProps, forcedEntityType]
	)

	return <PageContext.Provider value={contextValue}>{children}</PageContext.Provider>
}

export default PageProvider
export const usePageContext = () => useContext(PageContext)
